#import "../../../common/graphql/EntityDocumentsFields.graphql"
#import "../PayCyclePaymentsFragment.graphql"

query GetPayCycleDetails($id: UUID!) {
  payCycle(id: $id) {
    id
    __typename
    _urgencyLevel
    isDraft
    _rowTimestamp
    rowSecurityId
    transactionTypeId
    _documentPackageId
    paymentAccountId
     paymentAccount {
        name
        bankAccountNumber
      }
    description
    _isTransactionCancelled
    _isAccountingEntry
    _pendingApprovers
    defaultPaymentDate
    controlTotalAmount
    _totalPayments
    _paymentCount
    _isDeletable
    _isProtected
    _isUpdatable
    _isApprovalHistoryExists
    _isStagedApprovalRequest
    _isApprovalRevocable
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    currency {
      isoCode
    }
   statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    payCycleHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    transactionType {
      description
      layoutType
      transactionType
    }
    corporatePeriodId
    payments(orderBy: PAYMENT_REFERENCE_ASC) {
      ...PayCyclePaymentsFragment
    }
  }
}
